export const PLANXGO_TRANSLATIONS = {
  en: {
    planxgo: {
      plantManagement: {
        title: 'Plant Management',
        subtitle: 'Welcome to plant management',
      },
    },
  },
  es: {
    planxgo: {
      plantManagement: {
        title: 'Gestión de Plantas',
        subtitle: 'Bienvenido a gestión de plantas',
      },
    },
  },
};
